import { useCallback, useEffect, useState } from "react";
import { AxiosRequest } from "_services/api";
import { toastErro } from "components/Toast";

const api = AxiosRequest.makeApi(process.env.REACT_APP_MS_AW);

export interface ConfiguracaoCrlv {
  id: number;
  clientId: string;
  nomeCliente?: string;
  criadoEm: string;
}

export function useConfiguracaoCrlv(ativo: boolean) {
  const [registros, setRegistros] = useState<ConfiguracaoCrlv[]>([]);
  const [loading, setLoading] = useState(false);

  const listar = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get<ConfiguracaoCrlv[]>("/impressao-etiqueta/configuracao-crlv");
      setRegistros(data);
    } catch (e: any) {
      toastErro(e?.response?.data?.message ?? e?.message ?? "Erro ao buscar configurações");
      setRegistros([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const adicionar = useCallback(
    async (clientId: string, nomeCliente?: string) => {
      await api.post("/impressao-etiqueta/configuracao-crlv", { clientId, nomeCliente });
      await listar();
    },
    [listar],
  );

  const remover = useCallback(
    async (clientId: string) => {
      await api.delete(`/impressao-etiqueta/configuracao-crlv/${clientId}`);
      await listar();
    },
    [listar],
  );

  useEffect(() => {
    if (ativo) listar();
  }, [ativo, listar]);

  return { registros, loading, listar, adicionar, remover };
}
